export enum HistoryOrderField {
  ACTION = 'action',
  RESTAURANT_NAME = 'restaurantName',
  DATE_TIME = 'dateTime',
}
